import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComunicationService } from './Services/comunication.service';
import { UserService } from './Services/userservice.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private _elementRef: ElementRef, 
    private userService: UserService, 
    private router: Router, 
    private comunicacion: ComunicationService
  ) { }

  super = false
  logged = false
  ngOnInit():void{
    this.comunicacion.obs_super.subscribe(data => {
      this.super = data;
      let rol = localStorage.getItem('role')

      if (rol) {
        this.logged = true
      }
    })
    this._elementRef.nativeElement.removeAttribute("ng-version");




  }



  logout() {

    this.userService.logout()
    this.logged = false;
    this.super = false;
    this.router.navigate(['login']);
  }
}
